import { CounterInput } from 'components/CounterInput'
import { Formik } from 'formik'
import { ComponentType, useState } from 'react'
import { Button, Form } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { hasFilters } from 'utils/filters'
import { Filter } from 'views/search/filter'

const Body = styled.div`
  padding: 20px;

  ${up('sm')} {
    padding: 32px;
    width: 250px;
  }
`

interface Props {
  query: any
  onSubmit: (changes: any) => void
}

export const Bathrooms: ComponentType<Props> = ({ query, onSubmit }) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleToggle = () => setIsOpen(!isOpen)

  const initialValues = {
    places: { 'bathrooms>': query.places?.['bathrooms>'] ?? '' },
  }

  const resetValues = {
    places: { 'bathrooms>': '' },
  }

  return (
    <Filter
      label={`Baños ${initialValues.places['bathrooms>']}`}
      isOpen={isOpen}
      isActive={hasFilters(initialValues)}
      onToggle={handleToggle}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values)
          handleToggle()
        }}
      >
        {({ values, setFieldValue, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Body>
              <div className="d-flex justify-content-between">
                <div className="text-trout">Baños</div>
                <CounterInput
                  value={values.places['bathrooms>']}
                  min={1}
                  max={100}
                  onChange={(value) => setFieldValue('places.bathrooms>', value)}
                />
              </div>
            </Body>
            <div className="border-top border-athens-gray py-15 px-30 d-flex justify-content-between">
              <Button
                type="button"
                color="link"
                className="p-0 text-raven"
                onClick={() => {
                  onSubmit(resetValues)
                  handleToggle()
                }}
              >
                Borrar
              </Button>
              <Button type="submit" color="link" className="p-0">
                Aplicar
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Filter>
  )
}
